import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import {  Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class PersonalDeContactoService {

  constructor(private apiService: ApiService) { 
    
  }

  
  GetAllContactListById(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getContactListByCompanyId}`;
    url = url.replace('{id}', id); 
    return this.apiService.get(url);
  }

  GetContactById(companyId: number): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getContactById}`;
    url = url.replace('{id}', companyId.toString()); 
    return this.apiService.get(url);
  }

  AddContact(contact: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.addContact}`;
    return this.apiService.post(url, contact);
  }
  
  UpdateContact(contact: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateContact}`;
    return this.apiService.put(url, contact);
  }

  DeleteContact(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.deleteContact}`;   
    url = url.replace('{id}', id); 
    return this.apiService.delete(url);
 }
 
}
